import React from 'react';
import { Link } from 'gatsby';
import { isEmpty } from 'lodash';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ColumnTwo } from './styles/Column.styled';
import { CampusIntroBlock, BlockContent, CampusBlock } from './styles/CampusBlock.styled';
import {
  CardImage,
  CardOneColumnSec,
  ButtonCardLM,
  OneColumnBox,
  CardWrapperOne,
  CardOneHeader,
  CardBodyOneColumn,
  BlockCardImage,
  ToggleTag,
  CardOneColumn,
} from './styles/FilterTabBlock.styled';
import BackToTop from './BackToTop';

import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';

export default function CampusList({ data, id, dir }) {
  const { translations } = React.useContext(DWTCContext);
  const [openedIndex, setOpenedIndex] = React.useState(-1);

  return (
    <div id="campusList">
      <CampusIntroBlock id={id}>
        <Container>
          <Row>
            <ColumnTwo>
              <BlockContent dir={dir}>
                <h3 dir={dir}>{data.title}</h3>
              </BlockContent>
            </ColumnTwo>
            <ColumnTwo>
              <BlockContent>
                <p>{data.text}</p>
              </BlockContent>
            </ColumnTwo>
          </Row>
        </Container>
      </CampusIntroBlock>
      <CampusBlock>
        <Container>
          <Row>
            {data.campusItems.map(
              ({ content: { title, subtitle, description, type, link, image } }, index) => (
                <ColumnTwo>
                  <OneColumnBox>
                    <CardWrapperOne className="card_minhgt_cmpus" dir={dir}>
                      <BlockCardImage className="block_img_Hgt" dir={dir}>
                      {isEmpty(image) || (
                        <CardImage src={image.url} />
                      )}
                      </BlockCardImage>

                      <div className="accordion-wrapper" dir={dir}>
                        <ToggleTag
                          className={`accordion-title ${openedIndex === index ? 'open' : ''}`}
                          onClick={() => setOpenedIndex(openedIndex === index ? -1 : index)}
                          dir={dir}
                        />
                        <CardOneColumn
                          isOpen={openedIndex !== index}
                          className={`accordion-item ${
                            openedIndex !== index ? 'collapsed' : 'active'
                          } cmpus_crd_clm`}
                        >
                          <CardOneColumnSec dir={dir}>
                            <CardOneHeader dir={dir} className="campus_card_header">
                              <span dir={dir}>{getTranslationByKey(translations, type)}</span>
                              <h3 dir={dir}>{title}</h3>
                            </CardOneHeader>
                            <CardBodyOneColumn className="crd_bdy_clm" dir={dir}>
                              <h4>{subtitle}</h4>
                              <p>{description}</p>
                              {link && (
                                <ButtonCardLM dir={dir}>
                                  <Link to={link.url} dir={dir} target="_blank" rel="noreferrer">
                                    {link.name}
                                  </Link>
                                </ButtonCardLM>
                              )}
                            </CardBodyOneColumn>
                          </CardOneColumnSec>
                        </CardOneColumn>
                      </div>
                    </CardWrapperOne>
                  </OneColumnBox>
                </ColumnTwo>
              ),
            )}
          </Row>
          <BackToTop position="campusList" dir={dir} />
        </Container>
      </CampusBlock>
    </div>
  );
}
